// tslint:disable
export var Extauth2ForgotPasswordStatus;
(function (Extauth2ForgotPasswordStatus) {
    // forgot password was successful
    Extauth2ForgotPasswordStatus[Extauth2ForgotPasswordStatus["Success"] = 0] = "Success";
    // forgot password failed
    Extauth2ForgotPasswordStatus[Extauth2ForgotPasswordStatus["Failed"] = 1] = "Failed";
    // forgot password invalid user
    Extauth2ForgotPasswordStatus[Extauth2ForgotPasswordStatus["InvalidUser"] = 1] = "InvalidUser";
    // forgot password account locked
    Extauth2ForgotPasswordStatus[Extauth2ForgotPasswordStatus["AccountLocked"] = 1] = "AccountLocked";
})(Extauth2ForgotPasswordStatus || (Extauth2ForgotPasswordStatus = {}));
Extauth2ForgotPasswordStatus['SUCCESS'] = 0;
Extauth2ForgotPasswordStatus['FAILED'] = 1;
Extauth2ForgotPasswordStatus['INVALIDUSER'] = 1;
Extauth2ForgotPasswordStatus['ACCOUNTLOCKED'] = 1;
//# sourceMappingURL=Extauth2ForgotPasswordStatus.js.map